// Here we will create dark and light theme variables

export const lightTheme = {
  body: '#FCF6F4',
  text: '#000000',
  fontFamily: "'Source Sans Pro', sans-serif",
  bodyRgba: '252, 246, 244',
  textRgba: '0,0,0',
};

export const DarkTheme = {
  body: '#000000',
  text: '#FCF6F4',
  fontFamily: "'Source Sans Pro', sans-serif",
  textRgba: '252, 246, 244',
  bodyRgba: '0,0,0',
};

export const gradientBackground = {
  body: 'linear-gradient(270deg, #2c3e50, #4834d4, #130f40, #30336b)',
};

// src/components/Themes.js
export const Light = {
  body: 'rgba(245, 245, 245, 0.9)',
  text: '#333333',
  textLight: '#555555',
  card: '#ffffff',
  expandedBg: '#f0f0f0',
  progressBg: '#e0e0e0',
  toggleBg: '#333333',
  toggleText: '#ffffff',
};

export const darkTheme = {
  body: 'rgba(30, 30, 30, 0.9)',
  text: '#f0f0f0',
  textLight: '#cccccc',
  card: '#2a2a2a',
  expandedBg: '#1a1a1a',
  progressBg: '#444444',
  toggleBg: '#f0f0f0',
  toggleText: '#333333',
};
